// extracted by mini-css-extract-plugin
module.exports = {"container":"e_DB","question":"e_EB","button":"e_FB","buttonNegative":"e_GB","buttonPositive":"e_HB","icon":"e_IB","iconNegative":"e_JB","iconPositive":"e_KB"};